// this contains named variables for the base tints and hues used in the other colour files.
// NOTE: These colours should never be used outside of fe-brary.
// Use colours from colour-scheme or color-atom-palette instead
export default (function () {
  return {
    colour: {
      allhomesPomegranate400: '#ea2755',
      allhomesPomegranate500: '#e81043',
      allhomesPomegranate600: '#d00e3c',
      allhomesCeruleanblue100: '#ccdffa',
      allhomesCeruleanblue400: '#0063e6',
      allhomesCeruleanblue600: '#0059cf',
      allhomesOrange100: '#fee1d9',
      allhomesOrange400: '#fe6d45',
      allhomesYellow100: '#ffeccc',
      allhomesYellow400: '#ffa200',
      allhomesAqua100: '#D2DABE',
      allhomesAqua400: '#8D9F72',
      allhomesPurple100: '#e7dbfc',
      allhomesPurple400: '#874df0',
      allhomesRed900: '#a20b2e',
      allhomesRed800: '#db003a',
      allhomesRed700: '#e81043',
      allhomesRed600: '#fb204a',
      allhomesRed500: '#ff2b4b',
      allhomesRed400: '#ff4963',
      allhomesRed300: '#f37182',
      allhomesRed200: '#f89aa6',
      allhomesRed100: '#ffceda',
      allhomesRed50: '#ffebf1',
      allhomesBlue900: '#1642c7',
      allhomesBlue800: '#0063e6',
      allhomesBlue700: '#0076f9',
      allhomesBlue600: '#0089ff',
      allhomesBlue500: '#0098ff',
      allhomesBlue400: '#0fa8ff',
      allhomesBlue300: '#51b8ff',
      allhomesBlue200: '#8acdff',
      allhomesBlue100: '#bbe1fe',
      allhomesBlue50: '#e3f3ff',
      allhomesNavy900: '#0b2047',
      allhomesNavy800: '#13305e',
      allhomesNavy700: '#1a396b',
      allhomesNavy600: '#234276',
      allhomesNavy500: '#29497e',
      allhomesNavy400: '#4b628e',
      allhomesNavy300: '#6a7da0',
      allhomesNavy200: '#93a1bb',
      allhomesNavy100: '#bdc6d7',
      allhomesNavy50: '#e5e8ee'
    }
  };
});